var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Migas-estadisticas"},_vm._l((_vm.migas),function(item,index){return _c('p',[(index)?_c('span',[_vm._v(">")]):_vm._e(),(index < _vm.migas.length - 1)?_c('button',{on:{"click":function($event){return _vm.changeMigas(index)}}},[_c('span',[_vm._v(_vm._s(item))])]):_c('strong',[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }